import { getLogger } from 'loglevel';

export const log = getLogger('DataTable');
